import { createSlice } from "@reduxjs/toolkit";

const initialStateValue = { email: "", password: '' }

export const userSlice = createSlice({
    name: "login",
    initialState: { value: initialStateValue },
    reducers: {
        logInFunctional: (state, action) => {
            state.value = action.payload;
        },
        logOutFunctional: (state) => {
            state.value = initialStateValue
        },
    },
});

export const { logInFunctional, logOutFunctional } = userSlice.actions;

export default userSlice.reducer;